<template>
    <section id="advantages" class="py-20 lg:py-28">
        <div class="container mx-auto px-4">
            <h2 v-if="content.heading" class="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
                {{ content.heading }}
            </h2>
            <p v-if="content.subheading" class="text-center text-muted-foreground mb-14 max-w-2xl mx-auto">
                {{ content.subheading }}
            </p>

            <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
                <div
                    v-for="(item, i) in items"
                    :key="i"
                    class="bg-card rounded-xl p-7 border border-border card-hover shadow-sm"
                >
                    <div class="w-12 h-12 rounded-lg bg-accent/15 flex items-center justify-center mb-4">
                        <BlockIcon :name="item.icon" class="text-accent" :size="24" />
                    </div>
                    <h3 class="text-lg font-bold text-foreground mb-2">{{ item.title }}</h3>
                    <p class="text-muted-foreground text-sm leading-relaxed">{{ item.desc }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BlockIcon from "./BlockIcon.vue";

export default {
    name: "ForWhomBlock",
    components: { BlockIcon },
    props: { content: { type: Object, default: () => ({}) } },
    computed: {
        items() {
            return this.content.items || [];
        },
    },
};
</script>
